function gaAction(eventCategory, eventAction, eventLabel, eventValue){
	if(typeof(__gaTracker) == 'function'){
		__gaTracker('send', 'event', eventCategory, eventAction, eventLabel, eventValue);
	}
}